(function () {
  'use strict';

  const MONEY_FORMAT =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: MONEY_FORMAT,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  class AthenaProduct {
    constructor(root) {
      this.root = root;
      this.picker = root.querySelector('variant-radios');
      if (!this.picker) return;

      const json = this.picker.querySelector('[data-athena-variants]');
      try {
        this.variants = JSON.parse(json.textContent);
      } catch (e) {
        this.variants = [];
      }

      this.styleIndex = parseInt(this.picker.dataset.styleIndex, 10) || 0;
      this.sizeIndex = parseInt(this.picker.dataset.sizeIndex, 10) || 0;

      this.fieldsets = Array.from(this.picker.querySelectorAll('fieldset'));
      this.sizeFieldset = this.sizeIndex
        ? this.fieldsets[this.sizeIndex - 1]
        : null;

      this.shownAs = root.querySelector('[data-athena-shown-as]');
      this.atcPrice = root.querySelector('[data-athena-atc-price]');
      this.sticky = root.querySelector('[data-athena-sticky]');
      this.stickyPrice = root.querySelector('[data-athena-sticky-price]');
      this.stickyMeta = root.querySelector('[data-athena-sticky-meta]');
      this.addButton = root.querySelector('[id^="ProductSubmitButton-"]');

      this.picker.addEventListener('change', () => this.sync());
      this.sync();
      this.watchStickyBar();
    }

    selectedValues() {
      return this.fieldsets.map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    currentVariant() {
      const values = this.selectedValues();
      return this.variants.find((v) =>
        values.every((val, i) => val === null || v['option' + (i + 1)] === val)
      );
    }


    sizesForStyle(styleValue) {
      if (!this.styleIndex || !this.sizeIndex) return [];
      const styleKey = 'option' + this.styleIndex;
      const sizeKey = 'option' + this.sizeIndex;
      const seen = [];
      this.variants.forEach((v) => {
        if (v[styleKey] !== styleValue) return;
        if (seen.indexOf(v[sizeKey]) === -1) seen.push(v[sizeKey]);
      });
      return seen;
    }

    applyConditionalSize() {
      if (!this.sizeFieldset || !this.styleIndex) return false;

      const styleValue = this.selectedValues()[this.styleIndex - 1];
      const sizes = this.sizesForStyle(styleValue);
      const single = sizes.length <= 1;

      this.sizeFieldset.classList.toggle('a-step--hidden', single);
      this.sizeFieldset.toggleAttribute('data-single-size', single);

      const inputs = Array.from(this.sizeFieldset.querySelectorAll('input'));
      let changed = false;
      inputs.forEach((input) => {
        const valid = sizes.indexOf(input.value) !== -1;
        input.disabled = !valid && single;
        input.closest('.a-step__options') &&
          input.nextElementSibling &&
          input.nextElementSibling.classList.toggle('a-opt--hidden', !valid);
      });

      const checked = this.sizeFieldset.querySelector('input:checked');
      if (!checked || sizes.indexOf(checked.value) === -1) {
        const fallback = inputs.find((i) => sizes.indexOf(i.value) !== -1);
        if (fallback && !fallback.checked) {
          fallback.checked = true;
          changed = true;
        }
      }
      return changed;
    }

    sync() {
      if (this.applyConditionalSize()) {
        this.picker.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const variant = this.currentVariant();
      const values = this.selectedValues();

      if (this.shownAs && this.styleIndex) {
        this.shownAs.textContent = values[this.styleIndex - 1] || '';
      }

      const price = variant && variant.available ? formatMoney(variant.price) : '';
      if (this.atcPrice) this.atcPrice.textContent = price ? ' — ' + price : '';
      if (this.stickyPrice) this.stickyPrice.textContent = price || '';
      if (this.stickyMeta) {
        this.stickyMeta.textContent = values
          .filter(Boolean)
          .filter((v) => !/^one size$/i.test(v))
          .join(' · ');
      }
    }

    watchStickyBar() {
      if (!this.sticky || !this.addButton) return;

      if (!('IntersectionObserver' in window)) {
        this.sticky.hidden = false;
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.sticky.hidden = !passed;
            this.sticky.classList.toggle('is-visible', passed);
          });
        },
        { rootMargin: '0px 0px -100% 0px', threshold: 0 }
      );
      observer.observe(this.addButton);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.a-pdp').forEach((root) => {
      if (root.dataset.athenaReady) return;
      root.dataset.athenaReady = 'true';
      new AthenaProduct(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
